var render = function render(){var _vm=this,_c=_vm._self._c;return _c('AppActionBase',_vm._b({attrs:{"bg":"transparent","icon-url":"/assets/icons/print.svg","alt":"Print","custom-class":`btn-print-style ${_vm.customClass}`},on:{"click":function($event){return _vm.$emit('click', $event)}}},'AppActionBase',_vm.$attrs,false))
}
var staticRenderFns = []

export { render, staticRenderFns }